import { combineReducers } from "@reduxjs/toolkit";
import { meReducer } from "./me";
import { lpReducer } from "modules/pages/lp";

export const pagesReducer = combineReducers({
  me: meReducer,
  lp: lpReducer
});
